import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Bell, MessageCircle, Copy, UserPlus, Check } from "lucide-react";

export const NotificationsBell = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const unread = items.filter((n) => !n.read).length;
  const mark = (n) => api.post(`/notifications/${n.id}/read`).then(load);
  const wa = (n) => {
    const phone = (n.client_phone || "").replace(/\D/g, "");
    window.open(phone ? `https://wa.me/${phone}?text=${encodeURIComponent(n.wa_text)}` : `https://wa.me/?text=${encodeURIComponent(n.wa_text)}`, "_blank");
    mark(n);
  };
  const copy = (n) => { navigator.clipboard.writeText(n.wa_text).catch(() => {}); toast.success("Mensagem copiada"); mark(n); };
  const addOwner = async (n) => {
    try {
      await api.post(`/processes/${n.pid}/sellers/add`, { name: n.owner_name });
      toast.success(`${n.owner_name} acrescentado como proprietário`);
      load();
      window.dispatchEvent(new Event("process-changed"));
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="notifications-btn" className="relative w-9 h-9 rounded-full grid place-items-center text-slate-500 hover:bg-slate-100 transition-colors">
          <Bell size={18} />
          {unread > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center" data-testid="notifications-count">{unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0">
        <div className="px-4 py-3 border-b border-slate-100 font-heading text-ec-green">Notificações</div>
        <div className="max-h-[420px] overflow-y-auto divide-y divide-slate-100">
          {items.length === 0 && <p className="px-4 py-6 text-sm text-slate-400">Sem notificações.</p>}
          {items.map((n) => (
            <div key={n.id} className={`px-4 py-3 text-sm ${n.read && !n.done ? "opacity-60" : ""}`} data-testid={`notification-${n.id}`}>
              <button onClick={() => { mark(n); navigate(n.kind === "pedido_acesso" ? "/definicoes" : n.kind === "impic" ? "/obrigacoes" : `/processo/${n.pid}${n.target || ""}`); }} className="text-left">
                <span className="font-mono text-xs text-ec-gold mr-1">{n.ref}</span>{n.title}
              </button>
              {n.missing_contacts?.length > 0 && (
                <p className="text-xs text-amber-700 mt-1">Preencha o {n.missing_contacts.join(" e o ")} do cliente no processo.</p>
              )}
              {n.action === "add_owner" && (n.done
                ? <div className="inline-flex items-center gap-1 text-xs text-green-700 mt-2" data-testid={`notif-owner-done-${n.id}`}><Check size={12} /> {n.owner_name} já é proprietário{n.done_by ? ` · ${n.done_by}` : ""}</div>
                : <button onClick={() => addOwner(n)} className="inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-lg bg-ec-green text-white font-semibold mt-2" data-testid={`notif-add-owner-${n.id}`}><UserPlus size={12} /> Acrescentar proprietário</button>)}
              {n.wa_text && <div className="flex gap-2 mt-2">
                <button onClick={() => wa(n)} className="inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-lg bg-ec-gold text-ec-green font-semibold" data-testid={`notif-wa-${n.id}`}><MessageCircle size={12} /> Enviar no WhatsApp</button>
                <button onClick={() => copy(n)} className="inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-lg border border-slate-200" data-testid={`notif-copy-${n.id}`}><Copy size={12} /> Copiar mensagem</button>
              </div>}
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
